/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import classes from "../order/order.module.css";
import DialogContent from "@mui/material/DialogContent";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";

// Get order props from parent (View Order page)
const ApprovalDialog = (props) => {
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const [taskId, setTaskId] = useState("");
  const [msg, setMsg] = useState("");
  const task = props.taskForm;

  const submitForm = async () => {
    setLoading(true);
    let data = {
      operation: "submitTaskForm",
      taskId: task.taskId,
      id: task.fields[0].id,
      value: fieldValue,
    };
    if (validateFormData(data)) {
      BusApiCall(
        "PATCH",
        `${constants.busV44UrlPublic}/subscriptionAdjustments/${props.adjustment.adjustmentId}`,
        data,
      )
        .then((res) => {
          setLoading(false);
          props.close(fieldValue);
          // setMsg(t('ADJUSTMENT_APPROVED_SUCCESFULLY'))
        })
        .catch((e) => {
          setLoading(false);
          setMsg(t("DEFAULT_ERROR_MESSAGE"));
        });
    } else {
      setLoading(false);
      setMsg(t("MANDATORY_FIELDS_MESSAGE"));
    }
  };

  const validateFormData = (data) => {
    if (data.taskId === "" || data.id === "" || data.value === "") {
      return false;
    } else {
      return true;
    }
  };

  const handleChange = (event) => {
    setFieldValue(event.target.value);
  };
  return (
    <React.Fragment>
      <Dialog
        disableScrollLock={true}
        PaperComponent={DraggableDialogPaper}
        maxWidth={"md"}
        fullWidth={true}
        open={props.isOpen}
      >
        <DialogTitle
          style={{ color: "#000000", cursor: "move" }}
          id="draggableDialogPaper"
        >
          {t("APPROVAL_FORM")}
        </DialogTitle>
        <div>
          <DialogContent dividers>
            <FormLabel
              component="legend"
              style={{
                fontSize: "20px",
                marginBottom: "12px",
                color: "#000000",
              }}
            >
              {t("DO_YOU_WANT_TO_APPROVE_OR_NOT")} ?
            </FormLabel>
            <RadioGroup
              style={{ marginLeft: "6px" }}
              inputClass={classes.inputClass}
              aria-label={t("DO_YOU_WANT_TO_APPROVE_OR_NOT")}
              name={t("DO_YOU_WANT_TO_APPROVE_OR_NOT")}
              value={fieldValue}
              onChange={handleChange}
            >
              <FormControlLabel
                style={{ marginBottom: "6px" }}
                value="Approve"
                control={<Radio />}
                label="Approve"
              />
              <FormControlLabel
                value="Reject"
                control={<Radio />}
                label="Reject"
              />
            </RadioGroup>
          </DialogContent>
        </div>
        <DialogActions>
          {/* {msg ?
                        <Button onClick={() => {
                            setFieldValue('');
                            //props.getSubscription();
                            props.close(false);
                            setLoading(false)
                        }}>{t('OK')}</Button>
                        :
                        <React.Fragment>
                            <Button onClick={() => {
                                props.close();

                            }}>
                                {t('CLOSE')}</Button>
                            <Button onClick={() => {
                                setTaskId({});
                                submitForm()
                            }}>{t('SUBMIT')}</Button>
                        </React.Fragment>
                    } */}
          <div style={{ width: "100%" }}>
            <div style={{ float: "left" }}>
              <span style={{ fontWeight: "bold", color: "#f44336" }}>
                {msg}
              </span>
            </div>
            <div style={{ float: "right" }}>
              <Button
                onClick={() => {
                  props.close(false);
                }}
                style={{ marginRight: "8px" }}
              >
                {t("CANCEL")}
              </Button>
              {
                <Button
                  onClick={() => {
                    submitForm();
                  }}
                >
                  {t("SUBMIT")}
                </Button>
              }
            </div>
            <div style={{ clear: "both" }}></div>
          </div>
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(ApprovalDialog);
